import { LoadingButton } from '@mui/lab';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useChangeFieldForm } from '../../../hooks/useChangeFieldForm';
import { authService } from '../../../services/auth/AuthService';
import { CustomInput } from '../../common/CustomInput/CustomInput';
import { StyledForm } from '../../common/StyledForm/StyledForm';
import { ChangeEmailFormProps } from './types';
import { validationChangeEmailSchema } from './validationSchema';

export const ChangeEmailForm: React.FC<ChangeEmailFormProps> = ({
  email,
  formTitle,
  btnText,
  cb,
}) => {
  const { t } = useTranslation();

  const {
    values,
    errors,
    handleSubmit,
    touched,
    setFieldTouched,
    handleChange,
    checkDisableButton,
  } = useChangeFieldForm(
    email,
    'email',
    validationChangeEmailSchema(t),
    authService.changeEmail.bind(authService),
    'profilePage.updateEmailForm.emailIsAlreadyInUse',
    cb,
  );

  return (
    <StyledForm onSubmit={handleSubmit}>
      <Stack direction="column" sx={{ gap: '15px' }}>
        <Typography color="common.white">{formTitle}</Typography>
        <Stack
          sx={{
            gap: '15px',
            display: 'grid',
            gridTemplateColumns: '1fr 110px',
          }}
        >
          <CustomInput
            fieldName={'email'}
            type="email"
            inputMode="email"
            autoComplete="email"
            label={t('userAuth.emailPlaceholder')}
            value={values.email || ''}
            onChange={(e) => {
              setFieldTouched('email');
              handleChange(e);
            }}
            error={touched['email'] && errors.email}
            shortInput={false}
            styles={{ width: '100%' }}
          />
          <LoadingButton
            variant="contained"
            color="primary"
            type="submit"
            sx={{
              flex: '1 1 auto',
              padding: '10px',
              width: '100%',
              maxHeight: '50px',
              maxWidth: '110px',
            }}
            disabled={checkDisableButton()}
          >
            {btnText}
          </LoadingButton>
        </Stack>
      </Stack>
    </StyledForm>
  );
};
